<template>
  <div class="homeActivityItem flex start" :style="{'z-index': index+2}" v-if="item">
    <div class="img" @click="goDetail" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
    </div>
    <div class="fonts flex-bd" @click="goDetail">
      <h3 class="title lineTwo">{{ item.name }}</h3>
      <div class="subs flex">
        <div v-if="item.holding_time">{{ item.holding_time | formatStandardDate }}</div>
        <div class="flex-bd" v-if="item.organizer">
          <span class="organize lineOne"
          :title="item.organizer | formatStandardSep">主办单位：{{ item.organizer | formatStandardSep }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityItem',
  props: {
    item: Object,
    homeMode: Boolean,
    index: String|Number
  },
  data() {
    return {
    }
  },
  methods: {
    goDetail() {
      try {
        if (this.$route.meta.detailPage) {
          this.$router.push({
            path: "/activity/" + this.item.id,
            query: {
              id: this.item.id
            }
          })
          return
        }
        let link = this.$router.resolve({
          path: "/activity/" + this.item.id,
          query: {}
        })
        window.open(link.href, '_blank');
      } catch (err) {
        this.$router.push({
          path: "/activity/" + this.item.id,
          query: {
            id: this.item.id
          }
        })
      }
    }
  },
}
</script>
<style lang="scss" scoped >
@import "@/assets/sass/_config";
.homeActivityItem {
  & + .homeActivityItem {
    &::before {
      content: '';
      width: 100%;
      height: 1px;
      position: absolute;
      z-index: 1;
      top: 0;
      right: 5px;
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #eee 60%);
    }
  }
  position: relative;
  padding: 20px 20px 25px 0;
  cursor: pointer;
  &:hover {
    .fonts {
      .title {
        color: $main-color;
      }
    }
  }
  .img {
    width: 120px;
    height: 70px;
    margin-right: 26px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .fonts {
    .title {
      height: 56px;
      font-size: 18px;
      line-height: 26px;
      transition: all 0.3s;
    }

    .subs {
      margin-top: 10px;
      color: #6d6d6d;
      font-size: 12px;
    }
  }
}
</style>